import { module } from 'stereomodularjs';


export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        if (window.dealerId) {
            this.el.querySelectorAll('a').forEach((el) => {
                el.href += '#dealer=' + window.dealerId;
            })
        }
        if (location.hash && location.hash.indexOf('dealer=') > -1) {
            const dealerId = location.hash.split('=')[1];
            this.el.querySelector('form').appendChild(this.createHiddenInput('Concessionnaire', dealerId));
        }
    }

    createHiddenInput(name, value) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        return input;
    }
}
